import {
  CompletePadelResult,
  CompletePickleballResult,
  CompleteTennisResult,
  CreateMatchResultDTO,
  PadelResult,
  PickleballResult,
  TennisResult,
  UpdateMatchDTO,
} from "../types/Result";
import client from "./axios";

const matchUrl = "https://internal-api.getmoveapp.com/api/v1/admin/matches";
//const matchUrl = "http://localhost:3000/api/v1/admin/matches";

export const Matches = {
  getMatch: (sportId: number, bookingId: string) =>
    client.get<{
      result:
        | CompletePadelResult
        | CompleteTennisResult
        | CompletePickleballResult;
    }>(`${matchUrl}/${sportId}/get/${bookingId}`),
  createMatch: (body: CreateMatchResultDTO) =>
    client.post<{ result: PadelResult | TennisResult | PickleballResult }>(
      `${matchUrl}/create`,
      body
    ),
  updateMatch: (sportId: number, id: string, body: UpdateMatchDTO) =>
    client.put<{ result: PadelResult | TennisResult | PickleballResult }>(
      `${matchUrl}/${sportId}/update/${id}`,
      body
    ),
  updateMatchPlayers: (sportId: number, id: string, body: UpdateMatchDTO) =>
    client.put<{ result: PadelResult | TennisResult | PickleballResult }>(
      `${matchUrl}/${sportId}/update-match-players/${id}`,
      body
    ),
};
